import styled from "styled-components";

import { theme } from "../../../styles/theme";

export const Container = styled.div`
  height: 100vh;
  padding: 30px;
  position: relative;
  overflow: hidden;
  display: flex;
  background-color: ${theme.colors.blue900};
  display: flex;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Main = styled.main`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

export const Header = styled.header`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  @media (min-width: 768px) {
    display: none;
  }
`;

export const Aside = styled.aside`
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100% - 40px);
  margin: 20px 0;
  width: 100%;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Img = styled.img`
  max-width: 100%;
  max-height: 100%;
  height: auto;
  width: auto;
  object-fit: contain;
`;

export const ButtonContainer = styled.div`
  position: absolute;
  z-index: 999;
  right: 10px;
  bottom: 10px;
`;
